module.exports = __webpack_public_path__ + "static/media/Conf.d5671fa0.jpg";